var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#2DC4E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89968 5.0827C3.50212 5.0827 4.12481 5.0422 4.72781 5.0962C4.99556 5.39713 5.05575 5.81901 5.26331 6.16719C7.96893 6.18069 10.6875 6.16719 13.3931 6.16719C13.5939 6.18069 13.8414 6.18745 13.9421 6.38826C14.0625 6.60932 13.9759 6.87032 13.8617 7.07113C13.3127 8.00207 12.7901 8.94651 12.2546 9.88363C12.0538 10.2189 11.9194 10.5935 11.6184 10.8551C11.3709 11.0626 11.0289 11.0756 10.7145 11.0756H6.96375C6.76293 11.0756 6.54862 11.0559 6.42825 10.895C6.04012 10.4596 5.832 9.90388 5.57775 9.39482C5.13744 8.51331 4.70654 7.62714 4.28512 6.73644C4.19793 6.53563 4.09106 6.35507 3.99037 6.16719C3.636 6.16719 3.2805 6.16719 2.93287 6.15369C2.86537 5.79932 2.86537 5.43763 2.89912 5.0827H2.89968ZM7.12518 11.7989C7.39767 11.7342 7.68099 11.7296 7.95543 11.7854C8.26312 11.8529 8.53143 12.0869 8.60512 12.3952C8.685 12.7496 8.685 13.1321 8.54437 13.4729C8.4105 13.7812 8.07581 13.9286 7.76137 13.9556C7.39968 13.982 6.98456 13.9556 6.71625 13.6873C6.42881 13.3661 6.42881 12.8975 6.489 12.4953C6.52893 12.1606 6.79725 11.8726 7.12518 11.7989ZM10.4732 11.7989C10.8079 11.7258 11.1696 11.732 11.4913 11.8524C11.799 11.9801 11.9599 12.3148 11.9863 12.6292C12.0268 12.9976 11.9863 13.4195 11.7186 13.7008C11.4711 13.9353 11.1094 13.9685 10.7814 13.9618C10.4597 13.9488 10.1121 13.8279 9.94444 13.5269C9.78471 13.2006 9.74201 12.8292 9.8235 12.4751C9.891 12.1471 10.1452 11.8732 10.4732 11.7989Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStq);
export default __webpack_public_path__ + "static/media/stq.ab55451b0044c7c9d750d2436ad49eac.svg";
export { ForwardRef as ReactComponent };